import {useFormik} from 'formik';

import NewPriceComponent from './NewPriceComponent';

import {useCreatePricingEntry} from '../hooks';

import {addPriceValidationSchema} from './validations';
import {PRICE_COMPONENT_MODES} from './constants';
import {EyeInvolvement} from '../constants';

interface INewPriceContainerProps {
  isModalOpen: boolean;
  handleCloseClick: () => void;
}

export interface IAddPriceFormValues {
  categoryId: string;
  categoryName: string;
  ccsdCode: string;
  description: string;
  eyeOption: 'one' | 'both' | '';
  price: string;
  doctorId?: string;
  consultationFee?: string;
  followupFee?: string;
}

const NewPriceContainer = ({
  isModalOpen,
  handleCloseClick,
}: INewPriceContainerProps) => {
  const {sendCreatePricingEntryRequest} = useCreatePricingEntry(() => {
    handleCloseClick();
  });

  const handleCreatePriceClick = (values: IAddPriceFormValues) => {
    const categoryName = values.categoryName;

    let payload: IPostPricingEntryPayload = {category_id: values.categoryId};

    if (categoryName === 'Consultation') {
      payload = {
        ...payload,
        doctor_id: values.doctorId,
        consultation_fee: values.consultationFee,
        followup_fee: values.followupFee,
      };
    } else {
      payload = {
        ...payload,
        ccsd_code: values.ccsdCode,
        description: values.description,
        procedure_price: String(parseFloat(values.price)),
        ...(categoryName !== 'Diagnostic/Other Fees' && {
          eye_involvement:
            values.eyeOption === 'both'
              ? EyeInvolvement.BothEyes
              : EyeInvolvement.OneEye,
        }),
      };
    }

    sendCreatePricingEntryRequest(payload);
  };

  const formik = useFormik<IAddPriceFormValues>({
    initialValues: {
      categoryId: '',
      categoryName: '',
      ccsdCode: '',
      description: '',
      eyeOption: '',
      price: '',
      doctorId: '',
      consultationFee: '',
      followupFee: '',
    },
    validationSchema: addPriceValidationSchema(
      PRICE_COMPONENT_MODES.ADD_PRICE_MODE
    ),
    onSubmit: handleCreatePriceClick,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    enableReinitialize: true,
  });

  return (
    <NewPriceComponent
      isModalOpen={isModalOpen}
      handleCloseClick={handleCloseClick}
      formik={formik}
    />
  );
};

export default NewPriceContainer;
